
























































































































































import {
  Component, mapState, Watch, mixins,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import { BasicLineConfig, BasicLineSetting } from '@/components/graphs/line/basic-line';
import {
  CommonsStore, MyaaffiliateStore, Payload, TierreportStore, AuthorizationStore,
} from '@samclick-store-factory';
import {
  getDateTodayIsoFormat, getStartOfCurrentMonth, formatDate, getEndDayOfDate,
} from '@/utils/date-utils';
import { getPercentageRate, toMoney, roundMoneyAmount} from '@/utils/common-utils';

class SubTierReportState {
    casino: string | number = ''

    serviceID: number = -1

    username: string= ''

    dayPeriod: Array<string> = [getStartOfCurrentMonth(), getDateTodayIsoFormat()]

    displayColumns: Array<string> = []

    isExporting: Boolean = false
}

@Component({
  /**
   * Imported components
   * */
  components: {},
  /**
   * Stores values
   * */
  computed: {
    ...mapState({
      loading: (state: any) => state.tierreport.tierreportStore.loading,
      metierreports: (state: any) => state.tierreport.tierreportStore.tierReport,
      metierGraphreports: (state: any) => state.tierreport.tierreportStore.tierReportGraph,
    }),
  },
  /**
   * Component properties
   * */
  props: {},
})
export default class SubTierReport extends mixins(SamclickMixins) {
  /**
   * Local state
   * */
    state = new SubTierReportState();

    payloadTemp = {};

    activeCasinos: { id: number, code: string }[] = []

    readonly USERNAME = 'name'

    readonly LEVEL = 'tier_level'

    readonly IMPRESSIONS = 'banner_displays'

    readonly HITS = 'clicks'

    readonly CLICK_CONVERSIONS = 'click_conversions'

    readonly SIGNUPS = 'registrants'

    readonly SIGNUP_CONVERSIONS = 'signup_conversion'

    readonly FTD = 'ftd'

    readonly FTD_CONVERSIONS = 'ftd_conversion'

    readonly ACTIVE_PLAYERS = 'active'

    readonly DEPOSITS = 'deposits'

    readonly DEPOSIT_COUNT = 'deposit_count'

    readonly WITHDRAwALS = 'withdrawals'

    readonly WITHDRAWALS_COUNT = 'withdraw_count'

    readonly SUB_AFF_PERCENTAGE = 'tier_reward_percentage'

    readonly SUB_AFF_COMMISSIONS = 'tier_reward'

  /**
   * Watchers
   * */
  @Watch('state.casino')
    casinoOnChanged(casino: number | string) {
      if (casino) {
        this.state.serviceID = CommonsStore.casinoAllDescription(Number(casino)).service_id;
      } else {
        this.state.serviceID = -1;
      }
    }

  /**
   * Methods
   * */
  generateLineConfig() {
    const setting = [
      new BasicLineSetting(this.$t('label.tier_commission').toString(), 'rgb(255, 99, 132)', 'commission', 'left', true),
      new BasicLineSetting(this.$t('label.signups').toString(), 'rgb(75, 192, 192)', 'registrations', 'right'),
    ];
    return new BasicLineConfig('date', setting);
  }

  submit(searchFromBtn: boolean = false, exportCsv: boolean = false) {
    const {
      username, dayPeriod, serviceID, casino,
    } = this.state;

    let casino_ids: (string | number)[] = []
    if (casino !== 0 && casino !== '') {
      casino_ids = [casino]
    } else {
      casino_ids = this.activeCasinos.map((casino) => casino.id);
    }

    const payload = {
      startDate: dayPeriod[0],
      endDate: `${formatDate(dayPeriod[1])}T00:00:00.000Z`,
      username,
      serviceId: serviceID > 0 ? serviceID : '',
      casinoIds: casino_ids,
      export: exportCsv,
    };

    payload.headers = [
      this.$t('label.username'),
      this.$t('label.level'),
      this.$t('label.impression'),
      this.$t('label.hits'),
      `${this.$t('label.click_conversion')}(%)`,
      this.$t('label.signups'),
      `${this.$t('label.signup_conversion')}(%)`,
      this.$t('label.ftds'),
      `${this.$t('label.ftd_conversion')}(%)`,
      this.$t('label.active_players'),
      this.$t('label.deposits'),
      this.$t('label.deposit_count'),
      this.$t('label.withdrawals'),
      this.$t('label.withdrawal_count'),
      `${this.$t('label.tier_commission_percentage')}(%)`,
      this.$t('label.tier_commission'),
    ];

    this.payloadTemp = payload;

    if (exportCsv) {
      this.state.isExporting = true
      TierreportStore.tierReportExport(new Payload(this.payloadTemp)).finally(() => {
        this.state.isExporting = false
      });
    } else {
      TierreportStore.getTierReport(new Payload(payload)).then(() => {
        TierreportStore.getTierGraphReport(new Payload(payload));
      });
    }
  }

  reset() {
    this.state = new SubTierReportState();
    this.submit(true, false);
  }

  sortClickConversion(a: any, b: any) {
    const rowA = parseFloat(a.banner_displays > 0 ? getPercentageRate(a.clicks, a.banner_displays).toString() : '0');
    const rowB = parseFloat(b.banner_displays > 0 ? getPercentageRate(b.clicks, b.banner_displays).toString() : '0');

    return rowA - rowB;
  }

  sortSignUpConversion(a: any, b: any) {
    const rowA = parseFloat(a.clicks > 0 ? getPercentageRate(a.registrants, a.clicks).toString() : '0');
    const rowB = parseFloat(b.clicks > 0 ? getPercentageRate(b.registrants, b.clicks).toString() : '0');

    return rowA - rowB;
  }

  sortFTDConversion(a: any, b: any) {
    const rowA = parseFloat(a.registrants > 0 ? getPercentageRate(a.ftd, a.registrants).toString() : '0');
    const rowB = parseFloat(b.registrants > 0 ? getPercentageRate(b.ftd, b.registrants).toString() : '0');

    return rowA - rowB;
  }

  displayDate() {
    const { dayPeriod } = this.state;
    const lang = this.$i18n.i18next.language;
    let start = [''];
    let end = [''];
    if (lang === 'en' || lang === 'br') {
      start = formatDate(dayPeriod[0], 'YYYY MMMM DD').split(' ');
      end = formatDate(dayPeriod[1], 'YYYY MMMM DD').split(' ');
    } else if (lang === 'jp') {
      start = formatDate(dayPeriod[0], 'YYYY MM DD').split(' ');
      start[0] = `${start[0]}年`;
      start[1] = `${start[1]}月`;
      start[2] = `${start[2]}日`;
      end = formatDate(dayPeriod[1], 'YYYY MM DD').split(' ');
      end[0] = `${end[0]}年`;
      end[1] = `${end[1]}月`;
      end[2] = `${end[2]}日`;
    }

    return [start, end];
  }

  getCasinoWithDaySales() {
    MyaaffiliateStore.GetCasinosWithDaySales(new Payload({
      affiliate_id: this.getAffiliateID,
    })).then((response: any) => {
      if (response.data) {
        this.activeCasinos = response.data;
      } else {
        this.activeCasinos = [];
      }
    });
  }

  /**
   * Computed
   * */

  get columnFilters() {
    return [
      { id: this.USERNAME, label: this.$t('label.username') },
      { id: this.LEVEL, label: this.$t('label.level') },
      { id: this.IMPRESSIONS, label: this.$t('label.impression') },
      { id: this.HITS, label: this.$t('label.hits') },
      { id: this.CLICK_CONVERSIONS, label: `${this.$t('label.click_conversion')}(%)` },
      { id: this.SIGNUPS, label: this.$t('label.signups') },
      { id: this.SIGNUP_CONVERSIONS, label: `${this.$t('label.signup_conversion')}(%)` },
      { id: this.FTD, label: this.$t('label.ftds') },
      { id: this.FTD_CONVERSIONS, label: `${this.$t('label.ftd_conversion')}(%)` },
      { id: this.ACTIVE_PLAYERS, label: this.$t('label.active_players') },
      { id: this.DEPOSITS, label: `${this.$t('label.deposits')}` },
      { id: this.DEPOSIT_COUNT, label: `${this.$t('label.deposit_count')}` },
      { id: this.WITHDRAwALS, label: `${this.$t('label.withdrawals')}` },
      { id: this.WITHDRAWALS_COUNT, label: `${this.$t('label.withdrawal_count')}` },
      { id: this.SUB_AFF_PERCENTAGE, label: `${this.$t('label.tier_commission_percentage')}(%)` },
      { id: this.SUB_AFF_COMMISSIONS, label: this.$t('label.tier_commission') },
    ];
  }

  get getAffiliateID() {
    let affiliate_id = AuthorizationStore.currentLoggedUserInState.id;
    if (affiliate_id === undefined || affiliate_id === null) {
      const local_json_string = localStorage.getItem('ma-auth.currentUser') as string;
      affiliate_id = JSON.parse(local_json_string).id;
    }

    return affiliate_id;
  }

  /**
   * Lifecycle hooks
   * */
  created() {
    this.getCasinoWithDaySales();
    this.submit(true, false);
    CommonsStore.fetchAllCasino();
  }

  mounted() {

  }

  beforeCreate() {
    this.commonUtil = {
      getPercentageRate,
      toMoney,
      roundMoneyAmount
    };
  }
}
